import React from "react";

const RunningLoan = () => {
  return <div>RunningLoan</div>;
};

export default RunningLoan;
